"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const core_1 = require("../types/core");
class Module {
    constructor(axiosInstance) {
        this.endpoint = "";
        this.axiosInstance = axiosInstance;
    }
    async _create(data, role = core_1.PartiuRole.user) {
        const { data: _data } = await this.axiosInstance.post(this.endpoint, data, {
            headers: {
                HTTP_USER_ROLE: role,
            },
        });
        return _data;
    }
    async _patch(id, data, role = core_1.PartiuRole.user) {
        const { data: _data } = await this.axiosInstance.patch(this.endpoint + `${id}/`, data, {
            headers: {
                HTTP_USER_ROLE: role,
            },
        });
        return _data;
    }
    async get(url, params = new URLSearchParams(), role = core_1.PartiuRole.user) {
        const { data } = await this.axiosInstance.get(url + "?" + params.toString(), {
            headers: {
                HTTP_USER_ROLE: role,
            },
        });
        return data;
    }
    async _list(page = undefined, params = {}, role = core_1.PartiuRole.user) {
        const _params = new URLSearchParams();
        if (page)
            _params.append("page", page.toString());
        Object.entries(params).forEach(([key, value]) => {
            let _value;
            if (value == undefined)
                return console.warn("Received undefined value, this value is not sent through the API");
            try {
                _value = value.toString();
            }
            catch {
                _value = value;
            }
            _params.append(key, _value);
        });
        const data = await this.get(this.endpoint, _params, role);
        if ("next" in data && "previous" in data)
            return data["results"];
        return data;
    }
    async _retrieve(id, role = core_1.PartiuRole.user) {
        const { data } = await this.axiosInstance.get(this.endpoint + `${id}/`, {
            headers: {
                HTTP_USER_ROLE: role,
            },
        });
        return data;
    }
    async _delete(id, role = core_1.PartiuRole.user) {
        await this.axiosInstance.delete(this.endpoint + `${id}/`, {
            headers: {
                HTTP_USER_ROLE: role,
            },
        });
    }
}
exports.default = Module;
//# sourceMappingURL=module.js.map